import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Paths } from '../../constants/paths';
import { getPartnerTierContent } from '../../utils/getPartnerTierContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PARTNER_TIERS = ['elite', 'diamond', 'platinum', 'gold', 'none'];
export function PartnerTierExplainer() {
  return /*#__PURE__*/_jsxs(Grid, {
    marginBlockStart: "1500",
    children: [/*#__PURE__*/_jsxs(GridItem, {
      size: {
        sm: 12,
        md: 6,
        lg: 5,
        xl: 5
      },
      marginBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.partnerTierExplainer.title"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplaceStorefront.partnerTierExplainer.subtitle_jsx",
        options: {
          linkProps: {
            external: true,
            href: 'https://knowledge.hubspot.com/resources/hubspot-solutions-directory-review-guidelines'
          }
        },
        elements: {
          Link,
          br: 'br'
        }
      })]
    }), /*#__PURE__*/_jsxs(GridItem, {
      size: {
        sm: 12,
        md: 6,
        lg: 4,
        xl: 4
      },
      offset: {
        sm: 0,
        md: 0,
        lg: 3,
        xl: 3
      },
      children: [/*#__PURE__*/_jsx(Logo, {
        marginBlockEnd: "500",
        name: "hubspot-wordmark"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h6",
        marginBlockEnd: "400",
        textTransform: "uppercase",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.partnerTierExplainer.programListTitle"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        gap: "200",
        flexDirection: "column",
        children: PARTNER_TIERS.map(tier => {
          const content = getPartnerTierContent(tier);
          if (!content) return null;
          const icon = content.icon ? /*#__PURE__*/_jsx(IconHolder, {
            color: "icon-core-default",
            icon: content.icon,
            padding: "0"
          }) : undefined;
          return tier !== 'none' ? /*#__PURE__*/_jsx(RouterLink, {
            to: `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?eco_PROFILE_SOLUTIONS_PARTNER_TIER=${tier}`,
            children: /*#__PURE__*/_jsx(MediaObject, {
              align: "center",
              itemLeft: icon,
              children: content.text
            })
          }, tier) : /*#__PURE__*/_jsx(Text, {
            marginInlineStart: "700",
            typography: "heading-50",
            children: content.text
          });
        })
      })]
    })]
  });
}